skrilla.filter('oddsFormat', function() {
    return function(string, decimals ) {
        const decimalPlaces = decimals ? parseInt(decimals) : 3;
        const odds = parseInt(string)
        console.log(odds, decimals)
        return (odds / 10000).toFixed(decimalPlaces)
    };
})
